import bossSCommon from '@/lib/bossSCommon'

/**
 * フォトクリッププレビューPC/SP共通 mixin
 */
export default {
  mixins: [bossSCommon],
  data () {
    return {
      photoClip: {
        companyName: '',
        photoInfoList: []
      }
    }
  },
  computed: {
    id () {
      return Number(this.$route.params.id)
    }
  },
  created () {
    this.fetchPhotoClip()
  },
  methods: {
    fetchPhotoClip () {
      this.$http.secured.get(this.apiPathForPhotoClip).then(response => {
        this.$set(this, 'photoClip', response.data)
      })
    }
  }
}
